


import { AnalyticsPropsContextInterface } from 'interface/interface'
import  { createContext } from 'react'

const AnalyticsPropsContext = createContext<AnalyticsPropsContextInterface| null>(null)
  

export default AnalyticsPropsContext